import { create } from "zustand";
import isEqual from "lodash-es/isEqual";

import { createSelectors } from "stores/createSelectors";
import type {
  ProductConfiguratorStore,
  ProductStore,
} from "components/_ProductConfigurator/store/ProductConfiguration.types";
import { productConfiguratorStoreActions } from "components/_ProductConfigurator/store/ProductConfiguratorStoreActions";
import { productConfiguratorTabsEnum, Unit } from "variables/enums";
import { useAuthStore } from "stores/authStore";
import { FeatureFlagKey } from "utils/featureFlags/resolveFlags/featureFlags.type";

export const initialState: ProductStore = {
  initialRequestParams: null,
  requestParams: null,
  productData: null,
  isLoading: false,
  productId: null,
  nodeId: undefined,
  productName: null,
  requestUnitsSystem: Unit.de_m3ph,
  resultUnitsSystem: Unit.de_m3ph,
  isModalView: false,
  isOrderCodeLoading: true,
  lang: "de",
  activeTab: productConfiguratorTabsEnum.productSuggestion,
  activePartModal: null,
  activePart: null,
  isConfigurationModalOpened: false,
  isProductChanged: false,
};

const useProductConfiguratorStoreBase = create<ProductConfiguratorStore>()(
  (set, get, store) => ({
    ...initialState,
    actions: productConfiguratorStoreActions(set, get, store),
  }),
);

export const useProductStateChanged = () =>
  useProductConfiguratorStoreBase(
    (state) =>
      state.productId &&
      !isEqual(state.requestParams, state.initialRequestParams),
  );

export const useProductConfiguratorStore = createSelectors(
  useProductConfiguratorStoreBase,
);

// They are called iterableParts, which means that EPF iterates over them when building the resulting list, so they should be disabled.
export const useIterableParts = () => {
  const activeTab = useProductConfiguratorStore.use.activeTab();
  const featureFlags = useAuthStore.use.featureFlags();
  const productData = useProductConfiguratorStore.use.productData();
  if (!featureFlags?.[FeatureFlagKey.PRODUCT_RESULTING_LIST]) {
    return null;
  }
  if (activeTab !== productConfiguratorTabsEnum.productSuggestion) {
    return null;
  }
  return productData?.product?.listViewConfiguration?.iterableParts;
};
